/**
 * Documentation spaces (card 4.3), pure: a project's spaces in order, which
 * page is in which space, and the selected space per project (remembered on
 * this device). `null` space = "Main".
 */
import { create } from 'zustand';

/** The project's spaces, by position then name. */
export function spacesOf(docSpaces = [], projectId) {
  return (docSpaces || [])
    .filter((s) => String(s.projectId) === String(projectId))
    .sort((a, b) => (a.position ?? 0) - (b.position ?? 0) || String(a.name).localeCompare(String(b.name)));
}

/** nodeId → spaceId for one project (only spaces that still exist). */
export function spaceAssignment(members = [], projectId, spaces = []) {
  const live = new Set(spaces.map((s) => String(s.id)));
  const out = new Map();
  for (const m of members || []) {
    if (String(m.projectId) === String(projectId) && live.has(String(m.spaceId))) out.set(String(m.nodeId), String(m.spaceId));
  }
  return out;
}

// ── selection, per project, per device ────────────────────────────────────
const KEY = 'apiboo.projectScope.docSpace.v1';
function read() {
  try {
    const raw = JSON.parse(window.localStorage.getItem(KEY) || '{}');
    return raw && typeof raw === 'object' ? raw : {};
  } catch {
    return {};
  }
}

export const useDocSpaceSelection = create((set) => ({
  byProject: read(),
  select(projectId, spaceId) {
    set((s) => {
      const byProject = { ...s.byProject, [String(projectId)]: spaceId || null };
      try {
        window.localStorage.setItem(KEY, JSON.stringify(byProject));
      } catch {
        /* storage unavailable: kept for this session */
      }
      return { byProject };
    });
  },
}));

/** The selected space of `projectId`, or null (Main) when none / it is gone. */
export function selectedSpaceOf(byProject, projectId, spaces = []) {
  const id = byProject?.[String(projectId)];
  return id && spaces.some((s) => String(s.id) === String(id)) ? String(id) : null;
}
